webpackJsonp([64],{

/***/ 1013:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TransferVehicle')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransferClassList_vue__ = __webpack_require__(776);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed33f208_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransferClassList_vue__ = __webpack_require__(1013);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransferClassList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed33f208_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransferClassList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 602:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + "/api/master/tariff/transfer";
/* harmony default export */ __webpack_exports__["a"] = ({
  getMasterClassname: function getMasterClassname(fareCategory) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("?fareCategory=" + fareCategory)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getListRate: function getListRate(filter) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/search" + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getListRateProvider: function getListRateProvider(filter) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/subscription" + filter)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getCommon: function getCommon(isSelfDrive) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + ("/common?selfDrive=" + isSelfDrive)).then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  create: function create(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt("return", _context5.sent);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  update: function update(request) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt("return", _context6.sent);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  subscription: function subscription(request) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + "/subscription", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt("return", _context7.sent);

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  activation: function activation(request) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + "/activation", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context8.abrupt("return", _context8.sent);

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  delete: function _delete(request) {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint, { data: request }).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context9.abrupt("return", _context9.sent);

            case 3:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  }
});

/***/ }),

/***/ 621:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_master_transferTariff_transferTariffService_js__ = __webpack_require__(602);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allPermissions.includes("Delete");
    },
    isAllowToSubscription: function isAllowToSubscription() {
      return this.allPermissions.includes("ToggleSubscription");
    }
  },
  data: function data() {
    return {
      allPermissions: [],
      items: [],
      isLoading: false,
      msg: "Please wait",
      userType: "Unspecified",
      fareCategory: null
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var profile, permissions;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$helper.scrollTop();

              _context.next = 3;
              return _this.$store.dispatch("user/getProfile");

            case 3:
              profile = _context.sent;
              permissions = profile.services[_this.$route.name];

              _this.userType = profile.userType;

              _this.fareCategory = _this.$route.path.split("/")[1];

              if (permissions) {
                _this.allPermissions = permissions;
              }

              if (!_this.isAllowToRead) {
                _context.next = 11;
                break;
              }

              _context.next = 11;
              return _this.getAll();

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  updated: function updated() {
    this.$helper.collapseMenu(this.fareCategory + "-tariff");
    this.$helper.setNavigationClass(this.fareCategory + "-transfer-link-new");
  },

  methods: {
    getAll: function getAll() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.isLoading = true;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2__services_master_transferTariff_transferTariffService_js__["a" /* default */].getMasterClassname(_this2.fareCategory);

              case 4:
                response = _context2.sent;

                _this2.items = response.data;
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

                if (_context2.t0.errors) {
                  for (index = 0; index < _context2.t0.errors.length; index++) {
                    _this2.$notification.error(_context2.t0.errors[index], { title: "Error" });
                  }
                }

              case 11:
                _context2.prev = 11;

                _this2.isLoading = false;
                return _context2.finish(11);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 8, 11, 14]]);
      }))();
    }
  }
});

/***/ }),

/***/ 689:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransferVehicle_vue__ = __webpack_require__(621);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04b5c395_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransferVehicle_vue__ = __webpack_require__(690);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransferVehicle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04b5c395_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransferVehicle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 690:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"section-header-info"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb"},[_c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v(_vm._s(_vm.$route.path.includes("selling") ? "Booker" : "Operator")+"\n                  Tariff")])]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("\n                Transfer Rates\n              ")])])]),_vm._v(" "),_vm._m(0)])])])]),_vm._v(" "),_c('section',{staticClass:"middle-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive table-p15"},[_c('table',{staticClass:"table table-hover table-fix"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('tr',{key:index,staticClass:"detail-row"},[_c('td',[_vm._v(_vm._s(item.masterClassName))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"button-action-wrapper"},[_c('router-link',{attrs:{"to":("/" + _vm.fareCategory + "/transfer/" + (item.masterClassId) + "?classname=" + (item.masterClassName))}},[(
                          _vm.isAllowToCreate ||
                          _vm.isAllowToUpdate ||
                          _vm.isAllowToDelete ||
                          _vm.isAllowToSubscription
                        )?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"}},[_c('span',[_vm._v("Manage")])]):_vm._e()])],1)])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"dataTables_info --blue25",staticStyle:{"padding-top":"15px","padding-bottom":"15px"}},[_c('strong',[_vm._v(_vm._s(_vm.items.length)+" Records")])])])])])]),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-header-info"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"pull-left"},[_c('h2',[_vm._v("\n                  Transfer Rates\n                  "),_c('span',[_c('i',{staticClass:"ic-price-calculator"})])]),_vm._v(" "),_c('p',[_vm._v("Manage all transfer rates based on vehicle class.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Class")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 776:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_master_transferTariff_TransferVehicle_vue__ = __webpack_require__(689);
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    TransferVehicle: __WEBPACK_IMPORTED_MODULE_0__components_master_transferTariff_TransferVehicle_vue__["a" /* default */]
  },
  updated: function updated() {
    this.$helper.collapseMenu("selling-tariff");
    this.$helper.setNavigationClass("selling-transfer-link-new");
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/64.2a44d223bba06cc2f19e.js